<p-dropdown
  [disabled]="disabled"
  [options]="options"
  [optionLabel]="optionLabel"
  (onChange)="selectionChange($event)"
  (onHide)="onHide()"
  (onClear)="onClear()"
  [required]="required"
  [(ngModel)]="selectedItem"
  [inputId]="inputId"
  [styleClass]="styleClass"
  [filter]="filter"
  [emptyFilterMessage]="emptyFilterMessage"
  [selectId]="selectId"
  [showClear]="showClear"
  [autoDisplayFirst]="autoDisplayFirst"
  [placeholder]="placeholderText"
>
</p-dropdown>
